import React from 'react';
import HarcirahKabuk from './kabuk';
import BenimHarcirahim from './BenimHarcirahim';

/**
 * Personel ekranı (/harcirah, 24.10.2026 ekran ayrımı) — her çalışan kendi seyahatlerini görür, yemek tutarlarını
 * ve yakıt fişlerini girer, onaya gönderir. Bilet, kiralama ve oteli rezervasyon personeli girer (burada salt okunur).
 */
export default function HarcirahPersonel() {
  return <HarcirahKabuk baslik="Benim Harcırahım"><BenimHarcirahim /></HarcirahKabuk>;
}
